import React from "react";

// T031 (symptom 2) — the thread pane has TWO distinct empty states that used to
// be conflated into a single one:
//
//   1. NO chat selected at all → "Select a chat". stream-chat-react renders
//      this via <Channel EmptyPlaceholder={…}> whenever neither the channel
//      prop nor the ChatContext channel has a cid.
//   2. A SELECTED chat that has zero messages → "No messages yet". This is
//      <Channel EmptyStateIndicator={…}>, which the library mounts INSIDE the
//      MessageList of an open channel (listType "message" / "thread").
//
// Inbox.js used to put the "Select a chat — Choose a conversation from the left
// panel" copy on slot 2 and leave slot 1 empty, so a freshly created,
// message-less chat looked unselected even though its header, composer and
// participants rail were all showing it.
//
// The English literals here are the i18n source strings — the static bundle
// (src/translations/components/inbox/inbox.json) keys off them; do not
// paraphrase them without updating that bundle.

const BubbleIcon = () => (
  <svg
    className="w-16 h-16 text-gray-300 mb-4"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"
    />
  </svg>
);

// Slot 1 — nothing selected. Verbatim the copy this pane always carried.
export const SelectAChatPlaceholder = () => (
  <div className="flex flex-col items-center justify-center h-full text-center p-8">
    <BubbleIcon />
    <h3 className="text-lg font-medium text-gray-700">Select a chat</h3>
    <p className="text-sm text-gray-500 mt-1">
      Choose a conversation from the left panel.
    </p>
  </div>
);

// Slot 2 — an OPEN chat whose first message hasn't been sent yet. Only the main
// message list gets the prompt; a thread (reply) list keeps Stream's silence.
export const NoMessagesYetIndicator = ({ listType }) => {
  if (listType === "thread") return null;
  return (
    <div className="flex flex-col items-center justify-center h-full text-center p-8">
      <BubbleIcon />
      <h3 className="text-lg font-medium text-gray-700">No messages yet</h3>
      <p className="text-sm text-gray-500 mt-1">
        Send the first message to start this conversation.
      </p>
    </div>
  );
};
